import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MftLpp0876Component } from './mft-lpp0876/mft-lpp0876.component';
import { MftLpp4476Component } from './mft-lpp4476/mft-lpp4476.component';
import { PaymentBreakdownComponent } from './payment-breakdown/payment-breakdown.component';
import { NsfReportsDateComponent } from './nsf-reports-date/nsf-reports-date.component';

@Component({
	selector: 'app-payment-breakdown-board',
	templateUrl: './payment-breakdown-board.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./payment-breakdown-board.component.scss'],
	imports: [
		MatTabGroup,
		MatTab,
		MftLpp0876Component,
		MftLpp4476Component,
		PaymentBreakdownComponent,
		NsfReportsDateComponent,
	],
})
export class PaymentBreakdownBoardComponent {}
